"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathParser = void 0;
const appendAttributePath_js_1 = require("../../../schema/actions/utils/appendAttributePath.js");
const index_js_1 = require("../../../schema/index.js");
class PathParser extends index_js_1.SchemaAction {
    constructor(schema, id = '') {
        super(schema);
        this.expressionAttributePrefix = `p${id}_`;
        this.expressionAttributeNames = [];
        this.expression = '';
        this.id = id;
    }
    setId(nextId) {
        this.id = nextId;
        this.expressionAttributePrefix = `p${nextId}_`;
        return this;
    }
    resetExpression(initialStr = '') {
        this.expression = initialStr;
        return this;
    }
    appendAttributePath(attributePath, options = {}) {
        return (0, appendAttributePath_js_1.appendAttributePath)(this, attributePath, options);
    }
    appendToExpression(projectionExpressionPart) {
        this.expression += projectionExpressionPart;
        return this;
    }
    parse(attributes) {
        const [firstAttribute, ...restAttributes] = attributes;
        if (firstAttribute === undefined) {
            return this;
        }
        this.appendAttributePath(firstAttribute);
        for (const attribute of restAttributes) {
            this.appendToExpression(', ');
            this.appendAttributePath(attribute);
        }
        return this;
    }
    toCommandOptions() {
        const ExpressionAttributeNames = {};
        this.expressionAttributeNames.forEach((expressionAttributeName, index) => {
            ExpressionAttributeNames[`#${this.expressionAttributePrefix}${index + 1}`] =
                expressionAttributeName;
        });
        const ProjectionExpression = this.expression;
        return {
            ExpressionAttributeNames,
            ProjectionExpression
        };
    }
    clone(schema) {
        const clonedParser = new PathParser(schema !== null && schema !== void 0 ? schema : this.schema, this.id);
        clonedParser.expressionAttributeNames = [...this.expressionAttributeNames];
        clonedParser.expression = this.expression;
        return clonedParser;
    }
}
exports.PathParser = PathParser;
